<template>
  <v-container fluid grid-list-md>
    <v-layout wrap justify-center align-center>
      <v-flex xs12 md10>
        <v-card>
          <v-toolbar flat dense light color="grey lighten-5">
            <v-toolbar-title>Rehber Kaydı Detayı</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-layout align-center justify-center >
                  <v-flex xs12 md10>
                    <v-card>
                      <v-card-text>
                        <v-form ref="detail" lazy-validation>
                          <v-container fluid grid-list-xs>
                            <v-layout wrap align-center>
                              <v-flex xs12>
                                <v-select
                                  v-model="data.contact.group_id"
                                  :items="data.groups"
                                  :rules="[$rules.empty('Gruplar')]"
                                  item-text="name"
                                  item-value="id"
                                  label="Gruplar"
                                  required>
                                </v-select>
                              </v-flex>
                              <v-flex md6 xs12 d-flex>
                                <v-text-field
                                  label="Ad"
                                  v-model="data.contact.name"
                                  required>
                                </v-text-field>
                              </v-flex>
                              <v-flex md6 xs12 d-flex>
                                <v-text-field
                                  label="Soyad"
                                  v-model="data.contact.surname"
                                  required>
                                </v-text-field>
                              </v-flex>
                              <v-flex xs12 d-flex>
                                <v-text-field
                                  label="Telefon Numarası"
                                  v-model="data.contact.phone"
                                  v-mask="'0(###) ### ## ##'"
                                  maxlength="16"
                                  :rules="[$rules.empty('Telefon Numarası')]"
                                  required>
                                </v-text-field>
                              </v-flex>
                              <v-flex xs12 d-flex>
                                <date-month-picker
                                    v-model="data.contact.birth_day"
                                    label="Doğum Tarihi"
                                    :required="false"
                                    :default="() => data.contact.birth_day"
                                    @on:date-selected="(val) => { data.contact.birth_day = val; }">
                                </date-month-picker>
                              </v-flex>
                              <v-flex
                                v-for="(custom, i) in data.customs"
                                :key="i"
                                xs6>
                                <v-text-field
                                  v-model="data.customs[i].val.value"
                                  :label="custom.val.alias"
                                  :value="custom.val.value"
                                  flat outlined>
                                </v-text-field>
                              </v-flex>
                            </v-layout>
                            <div class="text-xs-right">
                              <v-card-actions>
                                <v-btn dark @click="update">Güncelle</v-btn>
                                <v-btn  @click="deleteContact">Kaydı Sil</v-btn>
                              </v-card-actions>
                            </div>
                          </v-container>
                        </v-form>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import DateMonthPicker from '../../Components/SMSConstants/DateMonthPicker.vue';

export default {
  name: 'Detail',
  components: { DateMonthPicker },
  data: () => ({
    menu: false,
    data: {
      customs: [],
      contact: {},
      groups: [],
    },
    binder: {
      current: {},
      currentKey: '',
    },
  }),
  created() {
    this.onLoad();
  },
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    update() {
      if (this.$refs.detail.validate()) {
        const route = 'update/contact';
        const replicated = this.data.contact;
        replicated.phone = this.$mask.unmasked(replicated.phone);

        Object.entries(replicated)
          .forEach((el) => {
            if (el[0].includes('custom_field')) {
              delete replicated[el[0]];
            }
          });

        const data = { ...this.normalizedCustoms(), ...replicated };

        if (data.birth_day === '0000-00-00') {
          delete data.birth_day;
        }
        this.send({
          route,
          data,
        });
      }
    },
    async deleteContact() {
      return new Promise((resolve) => {
        this.$store.commit('fireConfirmation', async () => {
          const { id } = this.$route.params;
          const route = 'delete/contacts';
          const data = { id: [id] };

          this.send({ route, data })
              .then(() => this.$router.push({ name: 'dashboard' }));
          resolve();
        });
      });
    },
    normalizedCustoms() {
      const d = {};
      this.data.customs.forEach((el) => {
        d[el.key] = el.val.value;
      });

      return d;
    },
    onLoad() {
      const route = 'details/contact';
      const data = { id: [this.$route.params.id] };
      this.send({ route, data })
        .then(async (res) => {
          this.data.groups = res.data.data.groups;
          this.data.contact = await res.data.data.contact;

          Object.entries(this.data.contact)
            .forEach((el) => {
              if (el[0].includes('custom_field')) {
                if (el[1].alias !== null) {
                  this.data.customs.push({
                    key: el[0],
                    val: el[1],
                  });
                }
              }
            });

          ['updated_at', 'created_at', 'deleted_at'].map(el => delete this.data.contact[el]);
        });
    },
  },
};
</script>
